// extracted by mini-css-extract-plugin
export default {"mCard":"gD-z","image":"hD-z","imageNoBackground":"iD-z","imageHasCategory":"jD-z","fullWidth":"kD-z"};